// extracted by mini-css-extract-plugin
module.exports = {"drawerContainer":"MobileDrawerContainer_drawerContainer__tpCTx","drawerBlock":"MobileDrawerContainer_drawerBlock__KX4Yd"};